package de.oevbs.kunde.kundenportal2.components

import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kosmos.ui.icons.icon
import de.oevbs.kunde.kundenportal2.authentication.PortalSession.portalLogoutNotification
import de.oevbs.kunde.kundenportal2.contentToastContainer
import dev.fritz2.core.RenderContext
import dev.fritz2.headless.components.toast

private var toastCount = 0
private fun nextToastId() = "toast-${toastCount++}"

fun contentToast(
    content: RenderContext.() -> Unit
) {
    toast(
        containerName = contentToastContainer,
        duration = 0,
        classes = "relative",
        id = nextToastId()
    ) {
        div {
            content()
        }.clicks handledBy close //Wenn am Bild ein Routing Target ist, wird noch navigiert und dann geschlossen
        div("w-full flex justify-end absolute top-1 right-1") {
            button {
                icon(classes = "h-5 w-5 text-primary-500 font-semibold", icon = MaterialIconsOutlined.cancel)
            }.clicks handledBy close
            portalLogoutNotification handledBy close
        }
    }
}